import React, { useEffect, useState } from "react";
import html2canvas from "html2canvas"; // Import html2canvas
import "./Lifetime.scss";
import certificateImg from "../../assets/images/lifetime_payout.jpg";
import { Modal } from "@mui/material";
import downloadIcon from "../../assets/icons/download.svg";
import closeIcon from "../../assets/icons/cross-gray.svg";
import { FormatUSD } from "../../utilities/string";
import ShareCertiWithSocialmedia from "./ShareCertiWithSocialmedia";

function LifetimeCertificates({ data, publicShareTrue = false }) {
  const certificate = data;
  const [open, setOpen] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(
    publicShareTrue ? data : null
  );
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleOpen = (certificate) => {
    setSelectedCertificate(certificate);
    setOpen(true); // Open modal
    setImageLoaded(false);
  };

  const handleClose = () => {
    setOpen(false); // Close modal
    setSelectedCertificate(null);
  };

  const downloadCertificateWithDetails = () => {
    const certificateElement = document.getElementById("certificateContainer");

    if (certificateElement) {
      html2canvas(certificateElement, {
        scale: 4, // Ensure high resolution
        useCORS: true, // Enable cross-origin images
      }).then((canvas) => {
        // Create a new canvas for fixed dimensions
        const resizedCanvas = document.createElement("canvas");
        resizedCanvas.width = 1968; // Fixed width
        resizedCanvas.height = 1483; // Fixed height

        const context = resizedCanvas.getContext("2d");
        context.drawImage(
          canvas,
          0,
          0,
          canvas.width,
          canvas.height,
          0,
          0,
          resizedCanvas.width,
          resizedCanvas.height
        );

        // Convert resized canvas to image
        const dataUrl = resizedCanvas.toDataURL("image/png");

        // Trigger download
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `${selectedCertificate?.name}_certificate.png`;
        link.click();
      });
    } else {
      console.error("Certificate element not found for download.");
    }
  };

  const handleSmallDownload = () => {
    // Open the modal first
    setOpen(true);
    setSelectedCertificate(certificate);

    setTimeout(() => {
      // Trigger the download automatically
      downloadCertificateWithDetails();
    }, 300); // Adding a slight delay to ensure the modal is opened before the download happens
  };
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);
  return (
    <div className="lifetime_certificates">
      {/* Small certificate container */}
      {!publicShareTrue && (
        <div
          key={certificate.id}
          className="small_certificate_container"
          onClick={() => handleOpen(certificate)} // Open the modal on small image click
        >
          <div className="certificate_container_header">
            <span>
              <img
                onClick={(e) => {
                  e.stopPropagation();
                  handleSmallDownload(); // Trigger download and open modal
                }}
                src={downloadIcon}
                alt="Download"
                className="download_icon"
              />
            </span>
            <h3 className="certificate_title">{certificate?.title}</h3>
          </div>
          <div className="certificateImgContainer">
            <img
              src={certificateImg}
              alt="Certificate"
              className="small_certificate_image"
              style={{ cursor: "pointer" }}
            />

            {/* Certificate Name */}
            <div className="small_lifetime_certificate_name">
              {certificate?.name}
            </div>

            {/* Certificate Amount */}
            <div className="small_lifetime_certificate_amount">
              {FormatUSD(certificate?.amount)}
            </div>

            <div className="small_lifetime_certificate_date">
              {certificate?.created_at}
            </div>
          </div>
          <div
            className="frame-btn-container"
            style={{ marginTop: "10px", textAlign: "center" }}
          >
            <a
              href="https://fundedaward.com/products/ac-award?ta_aff=capital"
              target="_blank"
              rel="noreferrer"
              className="frame-certificate-btn"
            >
              Frame Certificate
            </a>
          </div>
        </div>
      )}

      {/* Modal for displaying the certificate in larger view */}
      {publicShareTrue ? (
        <div
          className={`${publicShareTrue ? "stage1certificateCardOverlayShare" : ""
            } certificate-modal`}
        >
          <div className="modal-content">
            <div
              className="certificate_container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="certificate_container_header">
                <span>
                  <img
                    onClick={(e) => {
                      e.stopPropagation();
                      downloadCertificateWithDetails();
                    }}
                    src={downloadIcon}
                    alt="Download"
                    className="download_icon"
                  />
                </span>
                <h3 className="certificate_title">
                  {selectedCertificate?.title}
                </h3>
                {!publicShareTrue && (
                  <img
                    onClick={handleClose}
                    src={closeIcon}
                    alt="Close"
                    className="close_icon"
                  />
                )}
              </div>
              <div className="certificatePopImage" id="certificateContainer">
                <img
                  src={certificateImg}
                  alt="Certificate"
                  className="certificate_image"
                  style={{ cursor: "pointer" }}
                  onLoad={() => setImageLoaded(true)}
                />

                {imageLoaded && (
                  <>
                    {/* Certificate Name */}
                    <div className="lifetime_certificate_name">
                      {selectedCertificate?.name}
                    </div>

                    {/* Certificate Amount */}
                    <div className="lifetime_certificate_amount">
                      {FormatUSD(selectedCertificate?.amount)}
                    </div>

                    {/* Certificate Date */}
                    <div className="lifetime_certificate_date">
                      {selectedCertificate?.created_at}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Modal open={open} onClose={handleClose}>
          <div className="certificate-modal" onClick={handleClose}>
            <div className="modal-content">
              <div
                className="certificate_container"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="certificate_container_header certificate_popModal_header">
                  <div className="topSection">
                    <h3 className="certificate_title">
                      {selectedCertificate?.title}
                    </h3>
                  </div>
                  <div className="bottomSection">
                    <span>
                      <img
                        onClick={(e) => {
                          e.stopPropagation();
                          downloadCertificateWithDetails();
                        }}
                        src={downloadIcon}
                        alt="Download"
                        className="download_icon"
                      />
                    </span>{" "}
                    <div
                      className="rightSection"
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <ShareCertiWithSocialmedia data={selectedCertificate} />
                      {!publicShareTrue && (
                        <img
                          onClick={handleClose}
                          src={closeIcon}
                          alt=""
                          className="close_icon"
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="certificatePopImage" id="certificateContainer">
                  <img
                    src={certificateImg}
                    alt="Certificate"
                    className="certificate_image"
                    style={{ cursor: "pointer" }}
                    onLoad={() => setImageLoaded(true)}
                  />

                  {imageLoaded && (
                    <>
                      {/* Certificate Name */}
                      <p className="lifetime_certificate_name">
                        {selectedCertificate?.name}
                      </p>

                      {/* Certificate Amount */}
                      <p className="lifetime_certificate_amount">
                        {FormatUSD(selectedCertificate?.amount)}
                      </p>

                      {/* Certificate Date */}
                      <p className="lifetime_certificate_date">
                        {selectedCertificate?.created_at}
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default LifetimeCertificates;
